import type React from 'react';

import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconStar } from '@change-corgi/design-system-legacy/icons';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { useHighlightText } from './hooks/useHighlightText';

type Props = {
	text: string;
	selected: boolean;
};

export const HighlightText: React.FC<Props> = ({ text, selected }) => {
	const {
		data: {
			backgroundColor,
			selectedBackgroundColor,
			borderColor,
			selectedBorderColor,
			textColor,
			selectedTextColor,
			iconColor,
			selectedIconColor,
		},
	} = useHighlightText();
	return (
		<Box
			sx={{
				textAlign: 'center',
				backgroundColor: selected ? selectedBorderColor : borderColor,
				marginBottom: -1,
				color: selected ? selectedTextColor : textColor,
				borderTopLeftRadius: 11, // the parent box has a border radius of 12, so we need to subtract 1px to avoid the border overlap
				borderTopRightRadius: 11, // the parent box has a border radius of 12, so we need to subtract 1px to avoid the border overlap
				alignItems: 'center',
				justifyContent: 'flex-start',
				display: 'flex',
				px: 24,
				pt: 16,
			}}
		>
			<Flex
				sx={{
					alignItems: 'center',
					justifyContent: 'center',
					py: 4,
					fontSize: 12,
					px: 8,
					borderRadius: 999,
					backgroundColor: selected ? selectedBackgroundColor : backgroundColor,
					gap: 4,
				}}
			>
				<Icon
					icon={iconStar}
					size="l"
					data-qa="ppmu-modal-highlight-icon"
					sx={{
						color: selected ? selectedIconColor : iconColor,
					}}
				/>
				<Text
					fontWeight="semibold"
					size="caption"
					data-qa="ppmu-modal-highlight-text"
					sx={{
						fontSize: 12,
						color: selected ? selectedTextColor : textColor,
					}}
				>
					{text}
				</Text>
			</Flex>
		</Box>
	);
};
